var map = {
	"./bottom.png": 3093,
	"./discharged.png": 2512,
	"./doc.png": 980,
	"./false.png": 3203,
	"./favicon.png": 3070,
	"./fingerprint.png": 3026,
	"./fingerprintError.png": 9650,
	"./fingerprintMatched.png": 3348,
	"./fingerprintNotMatched.png": 1047,
	"./login_right.png": 8066,
	"./logo.png": 317,
	"./lost_password.png": 1236,
	"./noData.png": 4925,
	"./not_found.png": 1768,
	"./patient.png": 8713,
	"./round-avatar.png": 554,
	"./top.png": 6543,
	"./true.png": 6708,
	"./user.png": 7701,
	"Assets/img/bottom.png": 3093,
	"Assets/img/discharged.png": 2512,
	"Assets/img/doc.png": 980,
	"Assets/img/false.png": 3203,
	"Assets/img/favicon.png": 3070,
	"Assets/img/fingerprint.png": 3026,
	"Assets/img/fingerprintError.png": 9650,
	"Assets/img/fingerprintMatched.png": 3348,
	"Assets/img/fingerprintNotMatched.png": 1047,
	"Assets/img/login_right.png": 8066,
	"Assets/img/logo.png": 317,
	"Assets/img/lost_password.png": 1236,
	"Assets/img/noData.png": 4925,
	"Assets/img/not_found.png": 1768,
	"Assets/img/patient.png": 8713,
	"Assets/img/round-avatar.png": 554,
	"Assets/img/top.png": 6543,
	"Assets/img/true.png": 6708,
	"Assets/img/user.png": 7701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6625;